import React, { useContext } from 'react';
import * as S from './styles';
import { MdDelete, MdEdit } from 'react-icons/md';
import { FaRegEye } from 'react-icons/fa';

import { TrainingProps } from 'types/TrainingProps';
import ListVerticalDragAndDrop from 'components/ListVerticalDragAndDrop';
import { formatDateBR, shrinkText } from 'utils/functions';
import { returnThumbYoutube } from 'utils/returnJSXs';
import Load from 'components/Load';
import LoadGeneralContext from 'context/LoadGeneralContext';
import { deleteTrainingReq } from './req';
import SystemNotifyContext from 'context/SystemNotifyContext';

type ListTrainingsProps = {
	trainings: TrainingProps[];
	isLoad: boolean;
	setTrainings: React.Dispatch<React.SetStateAction<TrainingProps[]>>;
	setTrainingToEditOrView: React.Dispatch<
		React.SetStateAction<TrainingProps | null>
	>;
	setIsOpenForm: React.Dispatch<React.SetStateAction<boolean>>;
	setViewPreview: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function ListTrainings({
	trainings,
	isLoad,
	setTrainings,
	setTrainingToEditOrView,
	setIsOpenForm,
	setViewPreview
}: ListTrainingsProps) {
	const { setMessage, setIsOpenLoad } = useContext(LoadGeneralContext);
	const { handleNotify } = useContext(SystemNotifyContext);

	async function deleteTraining(id: string) {
		setIsOpenLoad(true);
		setMessage('Deletando treinamento...');

		const isSuccess = await deleteTrainingReq(id);

		setIsOpenLoad(false);

		if (isSuccess) {
			const newList = trainings.filter((item) => item.id !== id);
			setTrainings(newList);
			handleNotify('Treinamento deletado com sucesso', 'success');
		} else {
			handleNotify('Erro ao deletar o treinamento', 'error');
		}
	}

	function ElementTraining(training: TrainingProps) {
		return (
			<S.training>
				{returnThumbYoutube(training.urlVideo, training.title)}

				<S.infos>
					<p>
						<b>Título: </b>
						{training?.title}
					</p>

					<S.htmlContent>
						<b>Conteúdo:</b>
						<p
							dangerouslySetInnerHTML={{
								__html: shrinkText(training?.description, 30)
							}}
						/>
					</S.htmlContent>

					<p>
						<b>URL botão: </b>
						{training?.content?.urlPdf}
					</p>

					<p>
						<b>Data: </b>
						{formatDateBR(training?.date || '')}
					</p>
				</S.infos>

				<S.actions>
					<FaRegEye
						onClick={() => {
							setViewPreview(true);
							setTrainingToEditOrView(training);
						}}
					/>
					<MdEdit
						onClick={() => {
							setIsOpenForm(true);
							setTrainingToEditOrView(training);
						}}
					/>
					<MdDelete
						onClick={() => {
							deleteTraining(training.id);
						}}
					/>
				</S.actions>
			</S.training>
		);
	}

	return (
		<S.container>
			{isLoad ? (
				<S.centralizeLoad>
					<Load showText text="Buscando treinamentos" />
				</S.centralizeLoad>
			) : (
				<>
					{trainings.length === 0 ? (
						<S.emptyList>
							<p>Não há treinamentos</p>
						</S.emptyList>
					) : (
						<S.box>
							<ListVerticalDragAndDrop
								showBtnDrag
								setListItens={setTrainings}
								listItens={trainings}
								sizeIconDrag="2.5rem"
								returnItemList={(value: TrainingProps) =>
									ElementTraining(value)
								}
							/>
						</S.box>
					)}
				</>
			)}
		</S.container>
	);
}
